webpackJsonp([269829036549620],{

/***/ 305:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(47);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(65);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _bloomer = __webpack_require__(25);
	
	var _hero = __webpack_require__(49);
	
	var _hero2 = _interopRequireDefault(_hero);
	
	var _servicesModule = __webpack_require__(569);
	
	var _servicesModule2 = _interopRequireDefault(_servicesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var services = [{
	  title: 'Implementation',
	  description: 'Full support and integration with your organization',
	  icon: 'cogs'
	}, {
	  title: 'Training',
	  description: 'Hands on personalized experience for your employees',
	  icon: 'chalkboard-teacher'
	}, {
	  title: 'Customization',
	  description: 'Customize ERPNext according to your requirements',
	  icon: 'wrench'
	}, {
	  title: 'Feature Development',
	  description: 'Build and enhance ERPNext with features not present in core',
	  icon: 'code'
	}];
	
	var Services = function Services(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'libermatic. - Services'
	      ),
	      _react2.default.createElement('meta', {
	        name: 'description',
	        content: 'libermatic provides ERPNext cloud service and support in Imphal, Manipur. Support services include, but not limited to, implementation, customization, training, migration and custom development.'
	      })
	    ),
	    _react2.default.createElement(
	      _hero2.default,
	      data.heroImage,
	      _react2.default.createElement(
	        _bloomer.Title,
	        null,
	        'Services'
	      )
	    ),
	    _react2.default.createElement(
	      _bloomer.Container,
	      { className: _servicesModule2.default.section },
	      _react2.default.createElement(
	        _bloomer.Content,
	        null,
	        _react2.default.createElement(
	          'p',
	          null,
	          'We provide cloud service and support to easily manage your business. The service we provide would be over ERPNext, a multi purpose business software with features including but not limited to billing, invoicing and inventory management, supported out of the box.'
	        )
	      ),
	      _react2.default.createElement(
	        _bloomer.Button,
	        {
	          isColor: 'info',
	          to: '/services/erpnext',
	          render: function render(props) {
	            return _react2.default.createElement(_gatsbyLink2.default, props);
	          }
	        },
	        'Learn More'
	      )
	    ),
	    _react2.default.createElement(
	      _bloomer.Container,
	      { className: _servicesModule2.default.section },
	      _react2.default.createElement(
	        _bloomer.Columns,
	        null,
	        _react2.default.createElement(
	          _bloomer.Column,
	          { isSize: '1/4' },
	          _react2.default.createElement(
	            _bloomer.Content,
	            null,
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Supports we provide'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _bloomer.Column,
	          { className: _servicesModule2.default.content },
	          _react2.default.createElement(
	            _bloomer.Content,
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              'Apart from the ERPNext hosting, we also various other services related to it. Although ERPNext is quite intuitive and easy to use, we can assist you during various stages of its usage. We think you should be able to use the full potential of this application.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'These services are sometimes clumped together in the packages we offer.'
	            )
	          ),
	          _react2.default.createElement(
	            _bloomer.Button,
	            {
	              isColor: 'primary',
	              to: '/services/pricing',
	              render: function render(props) {
	                return _react2.default.createElement(_gatsbyLink2.default, props);
	              }
	            },
	            'See Pricing'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _bloomer.Container,
	      { className: _servicesModule2.default.section },
	      _react2.default.createElement(
	        'div',
	        { className: _servicesModule2.default.pointers },
	        services.map(function (_ref2) {
	          var icon = _ref2.icon,
	              title = _ref2.title,
	              description = _ref2.description;
	          return _react2.default.createElement(
	            'div',
	            { key: title },
	            _react2.default.createElement(_bloomer.Icon, { className: 'fas fa-' + icon + ' fa-3x ' + _servicesModule2.default.icon }),
	            _react2.default.createElement(
	              'dl',
	              null,
	              _react2.default.createElement(
	                'dt',
	                null,
	                title
	              ),
	              _react2.default.createElement(
	                'dd',
	                null,
	                description
	              )
	            )
	          );
	        })
	      )
	    )
	  );
	};
	Services.propTypes = {
	  data: _propTypes2.default.shape({
	    heroImage: _propTypes2.default.object
	  }).isRequired
	};
	
	exports.default = Services;
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 569:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"section":"src-pages----services-module---section---1Mw5d","content":"src-pages----services-module---content---d2015","smallCaps":"src-pages----services-module---smallCaps---2wacy","pointers":"src-pages----services-module---pointers---2PnXk","icon":"src-pages----services-module---icon---2IUuY"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-services-js-548c16fc6bf733af1734.js